import { Grid, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useGetScenarioAttemptsQuery } from "../../services/tracking.service";
import { useGetScenesQuery } from "../../services/scene.service";
import { Params, useParams } from "react-router-dom";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";
import { EDraggableOptions } from "@virtus-tech-repository/virtus-tech-repository/lib/models/media.model";
import { useAppSelector } from "../../store/hooks";
import { VTButton, VTHTMLHotspot } from "@virtus-tech-repository/virtus-tech-repository";
import { useGetGroupHotspotsQuery, useGetHotspotsQuery } from "../../services/hotspot.service";
import { IHotspot } from "@virtus-tech-repository/virtus-tech-repository/lib/models/hotspot.model";

import {
    AdsClickRounded,
    VisibilityRounded,
    StartRounded,
    EditNoteRounded,
    ImageRounded,
    PlayCircleRounded,
    HourglassTopRounded,
    ArrowDropDownRounded,
    ArrowRightRounded,
} from "@mui/icons-material";
import ScoresHotspot from "./ScoresHotspot";

interface IProps {
    currentHotspotElement: IHotspot;
    questionActions: { action: string; data?: string; date: Date; questionId?: string }[];
    sortedHotspotActions: {
        hotspotId: string;
        questionId?: string;
        actions: { action: string; data?: string; date: Date }[];
    }[];
    answerHotspots: IHotspot[];
}

export default function VTScoresStopPoint({
    currentHotspotElement,
    questionActions,
    sortedHotspotActions,
    answerHotspots,
}: IProps) {
    const [showStopPointScores, setShowStopPointScores] = useState<boolean>(true);

    const questionAction = questionActions.find(
        (findElement: { action: string; data?: string; date: Date }) => findElement.action === "Question",
    );

    const filteredSortedHotspotActions = sortedHotspotActions.filter(
        (filterElement: {
            hotspotId: string;
            questionId?: string;
            actions: { action: string; data?: string; date: Date }[];
        }) => filterElement.questionId === currentHotspotElement.id,
    );

    return (
        <Grid
            item
            container
            justifyContent={"center"}
            sx={{
                border: "3px solid white",
                width: "700px",
                borderRadius: "15px",
                marginTop: "-10px",
                paddingTop: "30px",
                paddingBottom: "80px",
                position: "relative",
            }}
        >
            <Tooltip
                PopperProps={{ style: { zIndex: 100000 } }}
                title={
                    <VTButton
                        type={"list"}
                        startIcon={<HourglassTopRounded />}
                        endIcon={
                            <div style={{ marginLeft: "20px" }}>
                                {questionAction && (
                                    <>
                                        {new Date(questionAction.date).getHours().toString().length === 1 && "0"}
                                        {new Date(questionAction.date).getHours()}:
                                        {new Date(questionAction.date).getMinutes().toString().length === 1 && "0"}
                                        {new Date(questionAction.date).getMinutes()}:
                                        {new Date(questionAction.date).getSeconds().toString().length === 1 && "0"}
                                        {new Date(questionAction.date).getSeconds()}
                                    </>
                                )}
                            </div>
                        }
                    >
                        <div style={{ marginLeft: "-10px" }}>Stop Point</div>
                    </VTButton>
                }
                placement={"right"}
            >
                <Typography
                    align="center"
                    sx={{
                        backgroundColor: "#393939",
                        borderRadius: "15px",
                        padding: "7px",
                    }}
                >
                    {currentHotspotElement.contents.preClickContent.title !== undefined &&
                    currentHotspotElement.contents.preClickContent.title !== ""
                        ? currentHotspotElement.contents.preClickContent.title
                        : "Stop Point"}
                </Typography>
            </Tooltip>
            {showStopPointScores && (
                <Grid item container justifyContent={"center"}>
                    <hr
                        style={{
                            color: "#fff",
                            backgroundColor: "#fff",
                            height: "80px",
                            width: "3px",
                            marginTop: "0px",
                        }}
                    />
                </Grid>
            )}

            {showStopPointScores ? (
                <ArrowDropDownRounded
                    sx={{
                        position: "absolute",
                        zIndex: 100,
                        fontSize: "5em",
                        right: "0px",
                        top: "9px",
                        cursor: "pointer",
                    }}
                    onClick={() => setShowStopPointScores(!showStopPointScores)}
                />
            ) : (
                <ArrowRightRounded
                    sx={{
                        position: "absolute",
                        zIndex: 100,
                        fontSize: "5em",
                        right: "0px",
                        top: "9px",
                        cursor: "pointer",
                    }}
                    onClick={() => setShowStopPointScores(!showStopPointScores)}
                />
            )}

            {answerHotspots &&
                showStopPointScores &&
                filteredSortedHotspotActions.map(
                    (
                        sortedHotspotActionElement: {
                            hotspotId: string;
                            questionId?: string;
                            actions: { action: string; data?: string; date: Date }[];
                        },
                        elementIndex: number,
                    ) => {
                        const currentHotspotElement = answerHotspots.find(
                            (hotspotsFindElement: IHotspot) =>
                                hotspotsFindElement.id === sortedHotspotActionElement.hotspotId,
                        );

                        const currentDataInput: { action: string; data?: string; date: Date } | undefined =
                            sortedHotspotActionElement.actions.find(
                                (findElement: { action: string; data?: string; date: Date }) => findElement.data,
                            );

                        if (currentHotspotElement) {
                            return (
                                <>
                                    <Grid
                                        item
                                        container
                                        justifyContent={"center"}
                                        sx={elementIndex % 2 === 0 ? { paddingLeft: "60px" } : { paddingRight: "60px" }}
                                    >
                                        <Grid item sx={{ position: "relative" }}>
                                            <hr
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "#fff",
                                                    height: "3px",
                                                    width: "60px",
                                                    marginTop: "-10px",
                                                }}
                                            />
                                            <Grid
                                                item
                                                sx={
                                                    elementIndex % 2 === 0
                                                        ? {
                                                              marginRight: "-180px",
                                                              marginLeft: "180px",
                                                              marginTop: "-70px",
                                                              marginBottom: "-70px",
                                                              height: "120px",
                                                              width: "300px",
                                                              position: "relative",
                                                          }
                                                        : {
                                                              marginLeft: "-180px",
                                                              marginRight: "180px",
                                                              marginTop: "-70px",
                                                              marginBottom: "-70px",
                                                              height: "120px",
                                                              width: "300px",
                                                              position: "relative",
                                                          }
                                                }
                                                container
                                                alignContent={"center"}
                                                direction={elementIndex % 2 === 0 ? "row" : "row-reverse"}
                                            >
                                                {sortedHotspotActionElement.actions.filter(
                                                    (filterElement: { action: string; data?: string; date: Date }) =>
                                                        filterElement.action === "Input",
                                                ).length > 0 ? (
                                                    <Tooltip
                                                        title={"Data Entry"}
                                                        placement="bottom"
                                                        PopperProps={{ style: { zIndex: 100000 } }}
                                                    >
                                                        <EditNoteRounded
                                                            sx={
                                                                elementIndex % 2 === 0
                                                                    ? {
                                                                          border: "2px solid white",
                                                                          position: "absolute",
                                                                          top: "47px",
                                                                          left: "-43px",
                                                                          backgroundColor: "#222326",
                                                                          borderRadius: "50%",
                                                                          cursor: "pointer",
                                                                          fontSize: "1.8em",
                                                                      }
                                                                    : {
                                                                          position: "absolute",
                                                                          top: "47px",
                                                                          right: "-43px",
                                                                          backgroundColor: "#222326",
                                                                          borderRadius: "50%",
                                                                          cursor: "pointer",
                                                                          fontSize: "1.8em",
                                                                      }
                                                            }
                                                        />
                                                    </Tooltip>
                                                ) : sortedHotspotActionElement.actions.filter(
                                                      (filterElement: { action: string; data?: string; date: Date }) =>
                                                          filterElement.action === "Clicked",
                                                  ).length > 0 ? (
                                                    <Tooltip
                                                        title={"Clicked"}
                                                        placement="bottom"
                                                        PopperProps={{ style: { zIndex: 100000 } }}
                                                    >
                                                        <AdsClickRounded
                                                            sx={
                                                                elementIndex % 2 === 0
                                                                    ? {
                                                                          position: "absolute",
                                                                          top: "47px",
                                                                          left: "-43px",
                                                                          backgroundColor: "#222326",
                                                                          borderRadius: "50%",
                                                                          cursor: "pointer",
                                                                          border: "2px solid white",
                                                                          fontSize: "1.8em",
                                                                          padding: "2px",
                                                                      }
                                                                    : {
                                                                          position: "absolute",
                                                                          top: "47px",
                                                                          right: "-43px",
                                                                          backgroundColor: "#222326",
                                                                          borderRadius: "50%",
                                                                          cursor: "pointer",
                                                                          border: "2px solid white",
                                                                          fontSize: "1.8em",
                                                                          padding: "2px",
                                                                      }
                                                            }
                                                        />
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip
                                                        title={"Hovered"}
                                                        placement="bottom"
                                                        PopperProps={{ style: { zIndex: 100000 } }}
                                                    >
                                                        <VisibilityRounded
                                                            sx={
                                                                elementIndex % 2 === 0
                                                                    ? {
                                                                          position: "absolute",
                                                                          top: "47px",
                                                                          left: "-43px",
                                                                          padding: "2px",
                                                                          backgroundColor: "#222326",
                                                                          borderRadius: "50%",
                                                                          cursor: "pointer",
                                                                          border: "2px solid white",
                                                                          fontSize: "1.8em",
                                                                      }
                                                                    : {
                                                                          position: "absolute",
                                                                          top: "47px",
                                                                          right: "-43px",
                                                                          padding: "2px",
                                                                          backgroundColor: "#222326",
                                                                          borderRadius: "50%",
                                                                          cursor: "pointer",
                                                                          border: "2px solid white",
                                                                          fontSize: "1.8em",
                                                                      }
                                                            }
                                                        />
                                                    </Tooltip>
                                                )}

                                                <Tooltip
                                                    title={
                                                        <>
                                                            {sortedHotspotActionElement.actions.map(
                                                                (
                                                                    hotspotActionElement: {
                                                                        action: string;
                                                                        data?: string;
                                                                        date: Date;
                                                                    },
                                                                    mapIndex: number,
                                                                ) => {
                                                                    if (
                                                                        !sortedHotspotActionElement.actions[
                                                                            mapIndex - 1
                                                                        ] ||
                                                                        hotspotActionElement.action !==
                                                                            sortedHotspotActionElement.actions[
                                                                                mapIndex - 1
                                                                            ].action
                                                                    ) {
                                                                        const dateObject = new Date(
                                                                            hotspotActionElement.date,
                                                                        );

                                                                        return (
                                                                            <VTButton
                                                                                type={"list"}
                                                                                startIcon={
                                                                                    hotspotActionElement.action ===
                                                                                    "Input" ? (
                                                                                        <EditNoteRounded />
                                                                                    ) : hotspotActionElement.action ===
                                                                                      "Clicked" ? (
                                                                                        <AdsClickRounded />
                                                                                    ) : (
                                                                                        <VisibilityRounded />
                                                                                    )
                                                                                }
                                                                                endIcon={
                                                                                    <div style={{ marginLeft: "20px" }}>
                                                                                        {dateObject
                                                                                            .getHours()
                                                                                            .toString().length === 1 &&
                                                                                            0}
                                                                                        {dateObject.getHours()}:
                                                                                        {dateObject
                                                                                            .getMinutes()
                                                                                            .toString().length === 1 &&
                                                                                            0}
                                                                                        {dateObject.getMinutes()}:
                                                                                        {dateObject
                                                                                            .getSeconds()
                                                                                            .toString().length === 1 &&
                                                                                            0}
                                                                                        {dateObject.getSeconds()}
                                                                                    </div>
                                                                                }
                                                                            >
                                                                                <div style={{ marginLeft: "-10px" }}>
                                                                                    {hotspotActionElement.action}
                                                                                </div>
                                                                            </VTButton>
                                                                        );
                                                                    }
                                                                },
                                                            )}
                                                        </>
                                                    }
                                                    placement={elementIndex % 2 === 0 ? "right" : "left"}
                                                    PopperProps={{ style: { zIndex: 100000 } }}
                                                >
                                                    <Tooltip
                                                        title={
                                                            currentDataInput !== undefined
                                                                ? "User Response: " + currentDataInput.data
                                                                : ""
                                                        }
                                                        placement="bottom"
                                                        disableHoverListener={currentDataInput === undefined}
                                                        PopperProps={{ style: { zIndex: 100000 } }}
                                                    >
                                                        <Grid
                                                            item
                                                            sx={{ height: "100%", marginTop: "-150px" }}
                                                            justifyContent={"center"}
                                                            alignContent={"center"}
                                                        >
                                                            <ScoresHotspot
                                                                currentHotspotElement={currentHotspotElement}
                                                                leftHotspot={elementIndex % 2 !== 0}
                                                            />
                                                        </Grid>
                                                    </Tooltip>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {elementIndex !== filteredSortedHotspotActions.length - 1 && (
                                        <Grid item container justifyContent={"center"}>
                                            <hr
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "#fff",
                                                    height: "80px",
                                                    width: "3px",
                                                    marginTop: "-10px",
                                                }}
                                            />
                                        </Grid>
                                    )}
                                </>
                            );
                        }
                    },
                )}
        </Grid>
    );
}
